"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EffectService = void 0;
class EffectService {
    constructor() {
        this.effectHandlers = new Map();
        this.tasks = [];
        this.enableTrace = false;
    }
    invoke(action) {
        if (action.type) {
            const handler = this.effectHandlers.get(action.type);
            if (handler) {
                const task = handler(action.payload);
                const result = { isMiddlewareResult: true };
                if (this.enableTrace && task && typeof task.then === 'function') {
                    result.value = this.addTask(task);
                }
                else {
                    result.value = Promise.resolve(task);
                }
                return result;
            }
        }
        return { value: Promise.resolve() };
    }
    addEffect(action, handler) {
        this.effectHandlers.set(action, handler);
    }
    addTask(task) {
        const traceTask = task
            .then((response) => {
            this.removeTask(task);
            return response;
        })
            .catch((reason) => {
            // should be handled by effect function
            // this catch should not be used
            this.removeTask(task);
            throw reason;
        });
        this.tasks.push(traceTask);
        return traceTask;
    }
    removeTask(task) {
        this.tasks.splice(this.tasks.indexOf(task), 1);
    }
}
exports.EffectService = EffectService;
